import { render, staticRenderFns } from "./AdminCardNovelies.vue?vue&type=template&id=528f1b0c"
import script from "./AdminCardNovelies.vue?vue&type=script&lang=js"
export * from "./AdminCardNovelies.vue?vue&type=script&lang=js"
import style0 from "./AdminCardNovelies.vue?vue&type=style&index=0&id=528f1b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports